import { GeneralTranslation } from "@swo/storefront";
import { ContentFulComponents, SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import React from "react";
import { RenderComponentsList } from "./RenderComponentsList";
import { A18y_MainContent } from "./a18y/a18y_MainContent";
import { Translated } from "../../domain/translations/translations";

type ComponentRendererProps = {
  components: Array<ContentFulComponents | string>;
  localeForNumberFormat: SwarovskiOptikLocaleFrontend;
  translations: Translated<GeneralTranslation>;
  noSpaceForFirstComponent?: boolean;
};

export const ComponentRenderer: React.FC<ComponentRendererProps> = ({
  components,
  localeForNumberFormat,
  translations,
  noSpaceForFirstComponent,
}) => {
  function getList() {
    const firstComponent = components[0];

    if (typeof firstComponent !== "string" && firstComponent?.__typename === "ComponentHeroImage") {
      const [first, ...rest] = components;

      const list = [[first], rest];
      return { list, mainContentIdx: 1 };
    }

    const list = [components];

    return { list, mainContentIdx: 0 };
  }

  const { list, mainContentIdx } = getList();

  return (
    <>
      {list.map((stack, idx, ctx) => {
        function getPreviousListLastComponent() {
          if (idx > 0) {
            const previousStack = ctx[idx - 1];
            if (!previousStack) {
              return undefined;
            }

            return previousStack[previousStack.length - 1];
          } else {
            return undefined;
          }
        }

        const previousListLastComponent = getPreviousListLastComponent();

        if (stack.length === 0) {
          return null;
        }

        const reactKey = JSON.stringify(stack);

        const jsx = (
          <RenderComponentsList
            key={JSON.stringify(stack)}
            components={stack}
            localeForNumberFormat={localeForNumberFormat}
            translations={translations}
            noSpaceForFirstComponent={noSpaceForFirstComponent === false && idx === 0}
            previousListLastComponent={previousListLastComponent}
          />
        );

        return idx === mainContentIdx ? (
          <A18y_MainContent key={reactKey}>{jsx}</A18y_MainContent>
        ) : (
          <React.Fragment key={reactKey}>{jsx}</React.Fragment>
        );
      })}
    </>
  );
};
